module.exports = __webpack_public_path__ + "static/media/social-audience-right.ab0b102c.png";


//////////////////
// WEBPACK FOOTER
// ./client/components/AttachProductComponents/social-audience-right.png
// module id = 380
// module chunks = 0